import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Student page/Sidebar.css";
import logo from "../../Assets/EMEI logo.jpeg";
import {
  FaHome,
  FaBookOpen,
  FaCertificate,
  FaBriefcase,
  FaGift,
  FaUserGraduate,
  FaSignOutAlt,
} from "react-icons/fa";

const menuItems = [
  {
    id: 1,
    icon: <FaHome />,
    title: "Dashboard",
    active: true,
    target: "student-dashboard",
  },
  {
    id: 2,
    icon: <FaBookOpen />,
    title: "Courses",
    target: "student-courses",
  },
  {
    id: 3,
    icon: <FaCertificate />,
    title: "Certificates",
    target: "student-certificates",
  },
  {
    id: 4,
    icon: <FaBriefcase />,
    title: "Career",
    target: "student-career",
  },
  {
    id: 5,
    icon: <FaGift />,
    title: "Offers",
    target: "student-offers",
  },
  {
    id: 6,
    icon: <FaUserGraduate />,
    title: "Profile",
    target: "student-profile",
  },
  {
    id: 7,
    icon: <FaSignOutAlt />,
    title: "Logout",
  },
];

function Sidebar() {
  const [activeItem, setActiveItem] = useState(1);
  const navigate = useNavigate();

  const scrollToSection = (item) => {
    if (item.title === "Career") {
      navigate("/career");
      return;
    }
    if (!item.target) return;

    document.getElementById(item.target)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    setActiveItem(item.id);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("student");
    navigate("/login");
  };

  return (
    <aside className="student-page-sidebar" data-aos="fade-right" data-aos-duration="700">
      <div className="student-page-sidebar-logo" data-aos="fade-down" data-aos-delay="80" data-aos-duration="600">

        <div>
               <div className="logo-sidebar"><img src={logo} alt="EMEI logo" style={{borderRadius: "50%", width: "80px", height: "80px", objectFit: "cover"}} />EMEI</div>

        </div>
      </div>

      <ul className="student-page-sidebar-menu" data-aos="fade-left" data-aos-delay="120" data-aos-duration="650">
        {menuItems.map((item) => (
          <li
            key={item.id}
            className={`student-page-sidebar-menu-item ${activeItem === item.id ? "student-page-sidebar-active" : ""}`}
            onClick={() => {
              if (item.title === "Logout") {
                handleLogout();
                return;
              }
              scrollToSection(item);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                if (item.title === "Logout") {
                  handleLogout();
                  return;
                }
                scrollToSection(item);
              }
            }}
            role={item.target ? "button" : undefined}
            tabIndex={item.target ? 0 : undefined}
          >
            <span className="student-page-sidebar-icon">{item.icon}</span>
            <span>{item.title}</span>
          </li>
        ))}
      </ul>

      <div className="student-page-sidebar-footer" data-aos="fade-up" data-aos-delay="180" data-aos-duration="650">
        <div className="student-page-sidebar-support-card">
          <h4>Need Help?</h4>
          <p>Contact Student Support</p>
          <button className="student-page-sidebar-support-button">Contact</button>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
